(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premier-catalogue"] && !Shopify.designMode) return;
  try {
    
  // 正常页面直接加载外部脚本；此入口仅补足编辑器首次动态插入分区的情况。
  (() => {
    function loadCatalogueScript() {
      const root = document.querySelector('[data-premier-catalogue-script]');
      if (!root || customElements.get('premier-catalogue') || window.premierCatalogueLoading) return;
      window.premierCatalogueLoading = true;
      const script = document.createElement('script');
      script.src = root.dataset.premierCatalogueScript;
      script.dataset.premierCatalogueLoader = '';
      script.onload = () => { window.premierCatalogueLoading = false; };
      script.onerror = () => {
        window.premierCatalogueLoading = false;
        script.remove();
        console.error('【雕塑翻页画册】交互脚本加载失败，请检查主题资源是否完整同步');
        root.querySelector('[data-catalogue-part="book"]').textContent = 'Unable to load the catalogue. Please refresh.';
      };
      document.head.appendChild(script);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', loadCatalogueScript, { once: true });
    else loadCatalogueScript();
    document.addEventListener('shopify:section:load', loadCatalogueScript);
  })();

  } catch(e) { console.error(e); }
})();
})();
